import AddIcon from "@mui/icons-material/Add";
import { Button, Grid, Typography } from "@mui/material";
import { useState } from "react";
import MessagesForm from "../MessagesForm";
import styles from "./styles";

function AjouterMessages() {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <Grid className="messages" sx={styles}>
        <Grid container alignItems="center" style={{ marginTop: "3em" }}>
          <Button
            color="primary"
            variant="contained"
            className={"button"}
            onClick={() => setOpen(true)}
          >
            <AddIcon />
          </Button>
          <Typography className={"infoText"}>
            Pour créer un nouveau message, cliquez sur +
          </Typography>
        </Grid>
      </Grid>
      <MessagesForm
        open={open}
        onClose={() => setOpen(false)}
        selectedId={undefined}
        resetId={() => {}}
      />
    </>
  );
}

export default AjouterMessages;
